export const hasAuthTokenCb = () =>
  window.jwtKupo?.getAuthToken ||
  window.getAppAccessTokenCb ||
  window.Auth?.getAppAccessToken

export const getAuthToken = async () => {
  if (window.jwtKupo?.getAuthToken) {
    return window.jwtKupo?.getAuthToken()
  } else if (window.Auth?.getAppAccessToken) {
    return window.Auth.getAppAccessToken()
  } else if (window.getAppAccessTokenCb) {
    return new Promise((resolve, reject) => {
      window.getAppAccessTokenCb(resolve, reject)
    })
  }
}